import { ClientError } from './ClientError';

export default function FormClientError({ returnToForm, ...props }) {
	return (
		<ClientError {...props}>
			<p>
				The server was unable to process your submission. This can be caused by
				invalid data being entered into the form. Please double-check your form
				and try re-submitting. If you still receive errors after editing the
				form, follow the suggestions below.
			</p>
			<button
				type="button"
				className="btn btn-primary mb-3"
				onClick={returnToForm}>
				Return to Form
			</button>
		</ClientError>
	);
}
